import { render, staticRenderFns } from "./v-navbar-icon.vue?vue&type=template&id=447f4f01&scoped=true&"
import script from "./v-navbar-icon.vue?vue&type=script&lang=js&"
export * from "./v-navbar-icon.vue?vue&type=script&lang=js&"
import style0 from "./v-navbar-icon.vue?vue&type=style&index=0&id=447f4f01&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447f4f01",
  null
  
)

export default component.exports